export default __webpack_public_path__ + "static/media/listing-page-img.e65ea969.jpg";